import * as React from 'react'
import { object, func, bool, string } from 'prop-types'
import { Box, styled, IconButton, Modal } from '@mui/material'
import { Close } from '@mui/icons-material'
export default function CleanModal({
  children,
  title = '',
  onClose,
  status,
  sx
}) {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'background.paper',
    border: 'none',
    borderRadius: 1,
    boxShadow: 24,
    p: 0
  }

  const handleClose = () => {
    onClose(false)
  }

  const ModalTitle = styled(Box)(({ theme }) => ({
    background: theme.palette.leitura.main,
    padding: title === '' ? '0rem' : '0.75rem 1rem',
    color: 'white',
    fontSize: '1.75rem',
    fontWeight: 'bold',
    borderRadius: '5px 5px 0px 0px',
    display: 'flex',
    justifyContent: 'space-between'
  }))
  return (
    <Modal
      open={status}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...style, ...sx }}>
        <ModalTitle>
          {title}
          {title !== '' && (
            <IconButton onClick={() => handleClose()}>
              <Close style={{ fill: 'white' }} />
            </IconButton>
          )}
        </ModalTitle>
        <Box sx={{ p: 2 }}>{children}</Box>
      </Box>
    </Modal>
  )
}

CleanModal.propTypes = {
  children: object,
  onClose: func,
  status: bool,
  sx: object,
  title: string
}
